import { defineStore } from "pinia";
import apolloClient from "../plugins/apollo";
import { unsubscribe } from "@/gqls/auth";
import { useTracksStore } from "./tracks";
import { Howler } from "howler";
import { HTTP } from "@/http";
export const useAuthStore = defineStore("auth", {
    state: () => {
        return {
            isLoggedin: Boolean, // check user status 
            user: Object, // user data to be stored 
            token: "",
            isAuthenticatedUser: false,
            status: localStorage.getItem("status"),

        }
    },// end of state
    getters: {
        getUser: (state) => state.user,
        isAuthenticated: (state) => state.isAuthenticatedUser,
        getPhone: (state) => state.user.phone,
        getStatus: (state) => state.status,


    }, //end of getters 
    actions: {
        /**
         * 
         * subscribe 
         */
        async subscribeAction() {
            window.location.href="https://cgmtnsd.digitalsp.net/631/2rrbW";


        },
        /**
         * login user for authentication purpose 
         */
        async logIn() {

        },
        /**
        * checking user subscribtion status
        */
        async checkSubescriptionStatus(data) {
            const payloadCheck = {
                "CGMSISDN": data.phone,
                "CGSTATUS": "0"
            };
            const response = await HTTP.post(`auth/mtn/subscriptions/check`, payloadCheck);
            console.log("response: ", response);
            this.user = response.data.user;
            this.isAuthenticatedUser = response.data.status;
            this.isActive = response.data.isActive;
            await this.setData(response);

            // If condition is met, also call the campaign endpoint
            if (data.cgstatus == 0 || data.cgstatus == 5) {
                if (!data.clickID) {
                    console.error("pubId or clickId is missing");
                    return;
                }

                const payloadCampaign = {
                    pubID: data.pubID,
                    clickID: data.clickID,
                };
                HTTP.post(`auth/mtn/subscriptions/campaign`, payloadCampaign)
                    .then(res => {
                        console.log(res.data);
                    })
                    .catch(err => {
                        console.error(err);
                    });

            }
            return response;
        },
        async phoneFormated(phone) {
            var newPhone;
            if (phone.startsWith("09")) {
                newPhone = phone.substring(1)
                return "249" + newPhone;
            } else if (phone.startsWith("2499")) {
                return phone;
            } else if (phone.startsWith("9")) {
                return "249" + phone;
            } else if (phone.startsWith("002499")) {
                newPhone = phone.substring(5);
                return "249" + newPhone;
            } else {
                return false;
            }
        },
        async setData(response) {
            /**
             * @todo check for response code 101 == user subscribed but doesn't have active subscrbtion
             */

            if (response.data.token) {

                window.localStorage.setItem('user', JSON.stringify(response.data.user));
                window.localStorage.setItem('token', response.data.token);
                window.localStorage.setItem('status', response.data.token ? true : false);
                this.status = response.data.token ? true : false;
            } else {
                this.wipeUserData(response)
            }

        },
        async unsubscribe() {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                let phoneFormate = await this.phoneFormated(user.phone)

                return new Promise((resolve) => {
                    apolloClient
                        .mutate({
                            mutation: unsubscribe,
                            variables: {

                                msisdn: phoneFormate
                            }
                        }).then(async response => {
                            this.wipeUserData(response)
                                , resolve(response);


                        })

                })


            }
        },
        wipeUserData(response) {
            const player = useTracksStore();
            if (response.data?.checkSubscription?.code == "101" | response.data?.unsubscribe?.success | response.data?.unsubscribe?.message == "Not subscribed" | response.data?.unsubscribe?.message == "Unsubscribe successfully") {

                window.localStorage.removeItem("user"),
                    window.localStorage.removeItem("token"),
                    window.localStorage.removeItem("status"),
                    this.status = localStorage.getItem("status") ? true : false
                player.isPlaying = false,
                    Howler.stop()

            }
        },




        /**
         * logout the current authenticated user
         */
        async logOut() {
            const player = useTracksStore();

            (window.localStorage.removeItem("user"),
                window.localStorage.removeItem("token"),
                window.localStorage.removeItem("status"),
                this.status = localStorage.getItem("status") ? true : false),
                player.isPlaying = false,
                Howler.stop()

        },



    }
})